<template>
  <div>
    <select-delivery-method-component formAction="forcechallenge/selectphones"
                                      cancelLink="forcechallenge/cancel" />
  </div>
</template>
<style>
</style>

<script>
  import redirectHandler from 'utils/redirect';
  import SelectDeliveryMethod from '../../SignIn/components/select-delivery-method';

  export default {
    name: 'SelectPhones',
    components: {
      'select-delivery-method-component': SelectDeliveryMethod
    },
    methods: {
      async loginCancel(path) {
        const response = await this.$http.post(path);
        redirectHandler.checkAndRedirect(response, this.$router);
      }
    }
  };
</script>